// Generated by CoffeeScript 1.12.6
(function() {
  module.exports = {
    mixins: [require("ceri/lib/animate"), require("ceri/lib/structure"), require("ceri/lib/style"), require("ceri/lib/class"), require("ceri/lib/draghandle"), require("ceri/lib/util"), require("ceri/lib/events")],
    structure: function(){return [this.el("span",{"text":{":":"toast.text"}},[])]}
,
    events: {
      mouseenter: {
        dyn: true,
        cbs: "toast.removeTimeout"
      },
      mouseleave: {
        dyn: true,
        cbs: "toast.setTimeout"
      }
    },
    computedStyle: {
      "this": function() {
        return {
          zIndex: this.toast.zIndex
        };
      }
    },
    data: function() {
      return {
        toast: {}
      };
    },
    draghandle: {
      "this": {
        initStyle: {
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        style: function() {
          return {
            zIndex: this.toast.zIndex + 1
          };
        },
        onClick: function() {
          return this.toast.close();
        },
        onFirstMove: function() {
          return this.toast.removeTimeout();
        },
        onMove: function(delta, o) {
          var move;
          move = 3 * delta.x;
          if (move > this.offsetWidth) {
            move = this.offsetWidth;
          } else if (move < -this.offsetWidth) {
            move = -this.offsetWidth;
          }
          o.move = move;
          return this.move(o);
        },
        onEnd: function(delta, o) {
          if (o.move !== -this.offsetWidth && o.move !== this.offsetWidth) {
            this.$cancelLastandAnimate(this.unMove(o));
            return this.toast.setTimeout();
          } else {
            this.endMove(o);
            return this.toast.close(true);
          }
        }
      }
    },
    connectedCallback: function() {
      if (!this.toast.entered) {
        this.toast.entered = true;
        this.$cancelLastandAnimate(this.util.assign({
          el: this
        }, this.enter));
        return this.toast._close = (function(_this) {
          return function(cb) {
            return _this.$cancelLastandAnimate(_this.util.assign({
              el: _this
            }, _this.leave, {
              done: function() {
                _this.toast.onClose();
                _this.toast.entered = false;
                return cb();
              }
            }));
          };
        })(this);
      }
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-toaster/toast-component.js
// module id = 69
// module chunks = 1